module.exports = "<mat-form-field>\r\n    <mat-select [(value)]=\"selectedWorkplace\" [disabled]=\"isLoading\">\r\n        <mat-option *ngFor=\"let workplace of workplaces\" [value]=\"workplace\">\r\n            {{workplace.Name}}\r\n        </mat-option>\r\n    </mat-select>\r\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// ./client/app/activities/daily-activities/workplace-selector.component.html
// module id = 1259
// module chunks = 1